import { reducerCreatorProducer } from 'store/common'
import { ICacheState } from 'store/types/cache'
import { IAIVideoProject } from 'types/aiVideo'
import { PayloadAction } from '@reduxjs/toolkit'
import { IAIImageProject } from 'store/types/aiImage'

const reducers = reducerCreatorProducer<ICacheState>()({
  addToAiImageCache: (state, action: PayloadAction<IAIImageProject[]>) => {
    const items = action.payload
    items.forEach(item => {
      state.aiImageCache[item.images[0].id.toString()] = item
    })
  },
  addToAiVideoCache: (state, action: PayloadAction<IAIVideoProject[]>) => {
    const items = action.payload
    items.forEach(item => {
      state.aiVideoCache[item.id.toString()] = item
    })
  },
  addToAiAvatarCache: (state, action: PayloadAction<IAIVideoProject[]>) => {
    const items = action.payload
    items.forEach(item => {
      state.aiAvatarCache[item.id.toString()] = item
    })
  },

  removeFromAiImageCache: (state, action: PayloadAction<string[]>) => {
    action.payload.forEach(id => {
      delete state.aiImageCache[id]
    })
  },
  removeFromAiVideoCache: (state, action: PayloadAction<string[]>) => {
    action.payload.forEach(id => {
      delete state.aiVideoCache[id]
    })
  },
  removeFromAiAvatarCache: (state, action: PayloadAction<string[]>) => {
    action.payload.forEach(id => {
      delete state.aiAvatarCache[id]
    })
  }
})

export default reducers
